import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setDefaultProvince, setDefaultCity } from 'ui/store/defaultProvince/actions';
import useIsNativeView from './useIsNativeView';
import { IRootState } from '../store';

const useDefaultProvince = () => {
  const { defaultProvince, defaultCity } = useSelector(
    (state: IRootState) => state.defaultProvince
  );

  const dispatch = useDispatch();
  const isNativeView = useIsNativeView();

  useEffect(() => {
    const getSessionData = () => {
      const defaultProvinceFromSessionStorage = sessionStorage.getItem('defaultProvince')
        ? JSON.parse(sessionStorage.getItem('defaultProvince'))
        : null;
      const defaultCityFromSessionStorage = sessionStorage.getItem('defaultCity')
        ? JSON.parse(sessionStorage.getItem('defaultCity'))
        : null;

      return {
        defaultProvinceFromSessionStorage,
        defaultCityFromSessionStorage,
      };
    };

    const { defaultProvinceFromSessionStorage, defaultCityFromSessionStorage } = getSessionData();

    dispatch(setDefaultProvince(defaultProvinceFromSessionStorage));
    dispatch(setDefaultCity(defaultCityFromSessionStorage));
  }, []);

  // Save defaultProvince to session storage
  const saveDefaultProvince = (defaultProvince) => {
    const defaultProvinceFromSessionStorage = sessionStorage.getItem('defaultProvince')
      ? JSON.parse(sessionStorage.getItem('defaultProvince'))
      : null;

    // Set defaultProvince value if no defaultProvince or defaultProvince is not from branch detail page
    if (
      !defaultProvinceFromSessionStorage ||
      !defaultProvinceFromSessionStorage.fromBranchPage ||
      isNativeView
    ) {
      sessionStorage.setItem('defaultProvince', JSON.stringify(defaultProvince)); // Save defaultProvince to session storage
      dispatch(setDefaultProvince(defaultProvince)); // Set defaultProvince to state
    }
  };

  // Save defaultCity to session storage
  const saveDefaultCity = (defaultCity) => {
    const defaultCityFromSessionStorage = sessionStorage.getItem('defaultCity')
      ? JSON.parse(sessionStorage.getItem('defaultCity'))
      : null;

    // Set defaultCity value if no defaultCity or defaultCity is not from branch detail page
    if (
      !defaultCityFromSessionStorage ||
      !defaultCityFromSessionStorage.fromBranchPage ||
      isNativeView
    ) {
      sessionStorage.setItem('defaultCity', JSON.stringify(defaultCity)); // Save defaultCity to session storage
      dispatch(setDefaultCity(defaultCity)); // Set defaultCity to state
    }
  };

  return {
    defaultCity,
    defaultProvince,
    saveDefaultCity,
    saveDefaultProvince,
  };
};

export default useDefaultProvince;
